"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("..");
const Dropdown = (0, react_1.forwardRef)(({ children, className, comparator, error, id, onChange, optionRenderer, options, showSelectOption = true, value, ...props }, ref) => {
    function selectionIndex() {
        const index = options.findIndex((option) => {
            if (comparator)
                return comparator(option, value);
            if (typeof value === 'object')
                return (0, lodash_isequal_1.default)(option, value);
            return option === value;
        });
        return index >= 0 ? index : undefined;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(__1.Label, { error: error, target: id, children: children }), (0, jsx_runtime_1.jsx)(__1.Form.Error, { error: error }), (0, jsx_runtime_1.jsxs)("select", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-select', className), id: id, name: id, onChange: onChange
                    ? (e) => {
                        const event = new CustomEvent('change', {
                            detail: {
                                name: id,
                                value: options[+e.target.value]
                            }
                        });
                        onChange(event);
                    }
                    : undefined, value: selectionIndex(), ...props, children: [showSelectOption && ((0, jsx_runtime_1.jsx)("option", { value: "", children: typeof showSelectOption === 'boolean'
                            ? '- Select -'
                            : showSelectOption.text })), options.map((option, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    (0, jsx_runtime_1.jsx)("option", { value: index, children: optionRenderer
                            ? optionRenderer(option)
                            : option }, `${id}--${index}`)))] })] }));
});
exports.default = Dropdown;
